import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Sidebar from "./SideNavbar";
import Dashboard from "../Dashboard/dashboard";
import Scheduled from "../Scheduled/scheduled";

import Playlists from "../Playlists/playlists";
import Users from "../Users/users";
import Support from "../Support/support";
import TopNavBar from "./topNavbar";
import { CreativeProvider } from "../../../context/CreativeContext";
import { PlaylistProvider } from "../../../context/PlaylistContext"; // Add this import

import { TopBarProvider } from "../../../context/TopBarContext";
import Creatives from "../Creatives/creatives";
import Screens from "../Screens/screens";
import { ScreenProvider } from "../../../context/ScreenContext";
import { UserProvider } from "../../../context/UserContext";

const MainLayout: React.FC = () => {
  return (
    <CreativeProvider>
      <TopBarProvider>
        <div className="flex h-screen bg-gray-50">
          {/* Sidebar */}
          <Sidebar />

          {/* Main Content Area */}
          <div className="flex-1 overflow-hidden bg-white">
            <TopNavBar />
            <div className="overflow-y-auto h-[calc(100vh-64px)]">
              <Routes>
                {/* Default route redirects to dashboard */}
                <Route
                  path="/"
                  element={<Navigate to="/dashboard" replace />}
                />

                {/* Main navigation routes */}
                <Route path="/dashboard" element={<Dashboard />} />
                
                {/* Wrap Scheduled with PlaylistProvider */}
                <Route 
                  path="/scheduled/*" 
                  element={
                    <PlaylistProvider>
                      <Scheduled />
                    </PlaylistProvider>
                  } 
                />
                
                <Route path="/creatives/*" element={<Creatives />} />
                <Route path="/playlists/*" element={<Playlists />} />
                <Route
                  path="/screens/*"
                  element={
                    <ScreenProvider>
                      <Screens />
                    </ScreenProvider>
                  }
                />
                <Route path="/users/*" element= {<UserProvider><Users /></UserProvider> }/>
                <Route path="/support/*" element={<Support />} />

                {/* Fallback for unknown routes */}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </div>
          </div>
        </div>
      </TopBarProvider>
    </CreativeProvider>
  );
};

export default MainLayout;